<div class="karaoke-container">
  <div class="audio-container">
    <button
      (click)="loadAndPlay($event)"
      [disabled]="(audio | async)?.hasError"
      *ngIf="!(audio | async)?.hasStarted && !(audio | async)?.isPlaying"
    >
      <mat-icon fontSet="material-icons-outlined" mat-list-icon color="accent"
        >play_circle_filled</mat-icon
      >
    </button>
    <button
      (click)="resume($event)"
      [disabled]="(audio | async)?.hasError"
      *ngIf="(audio | async)?.hasStarted && !(audio | async)?.isPlaying"
    >
      <mat-icon fontSet="material-icons-outlined" color="primary" mat-list-icon
        >play_circle_filled</mat-icon
      >
    </button>

    <button (click)="pause($event)" *ngIf="(audio | async)?.isPlaying">
      <mat-icon fontSet="material-icons-outlined" color="primary" mat-list-icon
        >pause_circle_filled</mat-icon
      >
    </button>

    <button
      (click)="restart($event)"
      [disabled]="!(audio | async)?.hasStarted || (audio | async)?.hasError"
    >
      <ng-container
        *ngIf="
          (audio | async)?.hasStarted && !(audio | async)?.hasError;
          else disabled
        "
      >
        <mat-icon
          color="primary"
          fontSet="material-icons-outlined"
          mat-list-icon
          >replay_circle_filled</mat-icon
        >
      </ng-container>
      <ng-template #disabled>
        <mat-icon
          class="disabled"
          fontSet="material-icons-outlined"
          mat-list-icon
          >replay_circle_filled</mat-icon
        >
      </ng-template>
    </button>
  </div>
  <div class="transcript-container" appTextSize [gradeLevel]="block.gradeLevel">
    <app-formatted-paragraph
      [mappedHTML]="mappedHTML"
      [paragraph]="paragraph"
      [currentTime$]="currentTime$.asObservable()"
    ></app-formatted-paragraph>
  </div>
</div>
